import axios from "axios";
// export const URLApi = "https://wwz0tq2k-5000.inc1.devtunnels.ms/api";
// export const URLApi="https://8kl4c01f-9889.inc1.devtunnels.ms/api";
export const URLApi="https://dforce.biz/api";

export function cutAfterDecimal(number, pos, dl, ac) {
  if (Number(number)) {
    if (dl) {
      const limit = dl?.decimalLimit[ac] > 0 ? dl?.decimalLimit[ac] : 5;
      const res =
        number?.toString()?.indexOf(".") > -1
          ? number
            .toString()
            .slice(0, number.toString().indexOf(".") + limit + 1)
          : number;
      return res;
    } else {
      const res =
        number?.toString()?.indexOf(".") > -1
          ? number.toString().slice(0, number.toString().indexOf(".") + pos + 1)
          : number;
      return res;
    }
  } else {
    return 0;
  }
}

const formatDateTime = (dateString) => {
  const date = new Date(dateString); // Create a Date object from the dateString
  const timestampInMilliseconds = date.getTime();
  return timestampInMilliseconds; // Return the timestamp
};
export async function genrateTicketdata(){
  try {

    const response = await axios.get(`${URLApi}/admin/genratedTicketdata`);
    console.log(response.data, "response.data")
    // const token = response.data.token;

    // if (token) {
    //   localStorage.setItem('adminToken', token); // Store token with the key 'adminToken'
    //   console.log("Token stored successfully in localStorage");
    // }
    return response.data;
  } catch (error) {
    console.log("Error login Admin:", error);
  }
}
export async function adminLogin(email, password) {
  try {
    const requestBody = {
      email: email,
      password: password,
    };

    const response = await axios.post(`${URLApi}/admin-login`, requestBody, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log(response.data, "response.data")
    const token = response.data.token;

    if (token) {
      localStorage.setItem('adminToken', token); // Store token with the key 'adminToken'
      console.log("Token stored successfully in localStorage");
    }
    return response.data;
  } catch (error) {
    console.log("Error login Admin:", error);
  }
}

export function replyTicket(
  ticketId,
  replymessage,
  replyfile,
  closed,
  subject,
  token
) {
  const formData = new FormData();
  console.log(replyfile, "replyfile")
  if (replyfile) {
    formData.append("reply", replyfile, replyfile.name);
  }
  // formData.append("mobile", mobile);
  // formData.append("tokenId", sessionId);
  formData.append("closed", closed);
  formData.append("message", replymessage);
  formData.append("subject", subject);
  formData.append("ticketId", ticketId);

  return axios
    .post(URLApi + "/reply-tickets", formData, {
      headers: {
        "Authorization": `Bearer ${token}`,
      }
    })
    .then((res) => res)
    .catch((e) => {
      console.log(e);
    });
}

export const getAllChatsList = async (token) => {
  try {
    const res = await axios.get(`${URLApi}/support-chats`, {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    })
    return res;
  } catch (error) {
    console.log(error)
  }
}

export function raisedTicketList(address, token) {
  return fetch(URL + "/tickets-list", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "allow-access-control-origin": "*",
      "Authorization": `Bearer ${token}`,
    },
    body: JSON.stringify({
      address: address,
      page: 1,
      limit: 10,
    }),
  })
    .then((res) => res.json())
    .catch((e) => {
      console.log(e, "Error in raisedTicketList()::apis.tsx");
    });
}

export async function daoUsersAdd(address, token) {
  try {
    const requestBody = {
      address: address,
    };

    const response = await axios.post(`${URLApi}/addDAOUser`, requestBody, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.log("Error login Admin:", error);
  }
}

export async function getDAOUserList(walletAddress, token) {
  try {

    const response = await axios.get(`${URLApi}/getDAOUserList`, {
      params: {
        address: walletAddress,
      },
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.log("Error getDAOUserList Admin:", error);
  }
}


export async function getAllStakeUsers(page, limit, filter, token) {
  try {

    const response = await axios.get(`${URLApi}/getAllStakeUsers`, {
      params: {
        page: page,
        limit: limit,
        address: filter
      },
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.log("Error getDAOUserList Admin:", error);
  }
}


export async function getStakeSummary(token) {
  try {

    const response = await axios.get(`${URLApi}/getStakeSummary`, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.log("Error getDAOUserList Admin:", error);
  }
}


export async function updateStakeSetting(newSettings, token) {
  try {
    const response = await axios.post(`${URLApi}/updateStakeSetting`, newSettings, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.log("Error login Admin:", error);
  }
}

export async function getStakeSetting(token) {
  try {
    const response = await axios.get(`${URLApi}/getStakeSetting`, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.log("Error getDAOUserList Admin:", error);
  }
}

export async function getTop3IdData(token) {
  try {
    const response = await axios.get(`${URLApi}/getTop3IdData`, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.log("Error getDAOUserList Admin:", error);
  }
}

export async function getUserNodeGroupData(page, limit, filter, type, token) {
  try {

    const response = await axios.get(`${URLApi}/getUserNodeGroupData`, {
      params: {
        page: page,
        limit: limit,
        address: filter,
        type: type
      },
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.log("Error getDAOUserList Admin:", error);
  }
}

export async function nodeGroupApproveAction(selectedIds, token) {
  try {
    const requestBody = {
      selectedIds: selectedIds,
    };
    const response = await axios.post(`${URLApi}/nodeGroupApproveAction`, JSON.stringify(requestBody), {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,

      },
    });
    console.log(response.data, "response.data")
    return response.data;
  } catch (error) {
    console.log("Error nodeGroupApproveAction:", error);
  }
}



export const getAllUserList = async (page, limit) => {
  try {

    const res = await axios.get(`${URLApi}/user-list`, {

      params: {
        page: page,
        limit: limit,
      }
    })
    return res?.data;
  } catch (error) {
    console.log(error)
  }
}


export const getActiveUserList = async (page, limit) => {
  try {

    const res = await axios.get(`${URLApi}/active-user-list`, {
      params: {
        page: page,
        limit: limit,
      }
    })
    return res;
  } catch (error) {
    console.log(error)
  }
}


export const getInactiveUserList = async (page, limit) => {
  try {

    const res = await axios.get(`${URLApi}/inactive-user-list`, {

      params: {
        page: page,
        limit: limit
      }
    })
    return res;
  } catch (error) {
    console.log(error)
  }
}


export const getTeamdata = async (user, page, limit, filter, token) => {
  try {

    const res = await axios.get(`${URLApi}/team-data`, {

      params: {
        user: user,
        page: page,
        limit: limit,
      },
      headers: {
        "Authorization": `Bearer ${token}`
      }
    })
    return res;
  } catch (error) {
    console.log(error)
  }
}

export const getPendingWithdrawList = async (page, limit, filter, token) => {
  try {

    const res = await axios.get(`${URLApi}/pending-withdraw`, {

      params: {
        page: page,
        limit: limit,
        address: filter
      },
      headers: {
        "Authorization": `Bearer ${token}`
      }
    })
    return res;
  } catch (error) {
    console.log(error)
  }
}
export const getApproveWithdrawList = async (page, limit, filter, token) => {
  try {

    const res = await axios.get(`${URLApi}/approve-withdraw`, {

      params: {
        page: page,
        limit: limit,
        address: filter
      },
      headers: {
        "Authorization": `Bearer ${token}`
      }
    })
    return res;
  } catch (error) {
    console.log(error)
  }
}
export const getLevelDeposit = async (page, limit, filter, token) => {
  try {

    const res = await axios.get(`${URLApi}/depositList`, {

      params: {
        page: page,
        limit: limit,
        address: filter
      },
      headers: {
        "Authorization": `Bearer ${token}`
      }
    })
    return res;
  } catch (error) {
    console.log(error)
  }
}

export const getDashboardData = async () => {
  try {
    const res = await axios.get(`${URLApi}/dashboardData`)
    return res;
  } catch (error) {
    console.log(error)
  }
}

export const getProfileData = async (user, token) => {
  try {

    const res = await axios.get(`${URLApi}/user-profile?user=${user}`, {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    })
    return res;
  } catch (error) {
    console.log(error)
  }
}


export const updateProfileData = async (user, updatedData, token) => {
  const response = await fetch(`${URLApi}/update-profile`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      "Authorization": `Bearer ${token}`
    },
    body: JSON.stringify({
      user: user,
      name: updatedData.fullName,
      email: updatedData.email,
      phone: updatedData.phoneNumber
    }),
  });

  if (!response.ok) {
    throw new Error('Failed to update profile');
  }

  return await response.json();
};